.dots {
  display: none;
  gap: 3px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: rgb(0 0 0 / 20%);
  border-radius: 50%;

  &:focus {
    outline: none;
  }
}

.dotActive {
  background-color: #000;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    display: flex;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    display: flex;
  }
}
